import React, { Fragment } from 'react';
import { Card, Checkbox, Col, Form, Icon, Input, message, Row, Select, Tag, Tooltip } from 'antd';

const { Option } = Select;

export default (props) => {

	const { getFieldDecorator } = props.form;
	const { imeiList, setImeiList, isNormalProduct, setIsNormalProduct, existedImeiList } = props;

	const [value, setValue] = React.useState('');

	const afterOptions = () => {
		return getFieldDecorator('weightUnit', {
			initialValue: 'g'
		})(
			<Select style={{ width: 80 }}>
				<Option value="g">G</Option>
				<Option value="kg">KG</Option>
			</Select>);
	};

	const renderTitle = (title, tooltipContent) => {
		return <Fragment>
			<span>{title} <Tooltip title={tooltipContent}><Icon type="info-circle" /></Tooltip></span>
		</Fragment>;
	};

	const handleAddImei = (evt) => {
		if (evt.key === 'Enter') {
			const value = evt.target.value;
			if (value) {
				if (!imeiList.includes(value)) {
					setImeiList([...imeiList, value]);
					setValue('');
				} else {
					message.error('IMEI bạn nhập đã tồn tại');
				}
			}
		}
	};

	const handleRemoveImei = (imei) => {
		setImeiList(imeiList.filter(tag => tag !== imei));
	};

	// const renderImeiOrNormal = () => {
	// 	if (!isNormalProduct) {
	// 		return <Col sm={24}>
	// 			<Form.Item label={'IMEI'}>
	// 				<Input value={value} allowClear placeholder={'Nhập IMEI'} onChange={e => setValue(e.target.value)}
	// 							 onKeyDown={handleAddImei} />
	// 				<div className={'mt-20'}>
	// 					<i>Danh sách IMEI ({imeiList.length}): </i>{imeiList.map((el) => <Tag key={el} style={{ marginBottom: 10 }} closable color={existedImeiList.find(e => e === el) ? 'red' : 'blue'}
	// 																																								onClose={() => handleRemoveImei(el)}>
	// 					{el}
	// 				</Tag>)}
	// 				</div>
	// 			</Form.Item>
	// 		</Col>;
	// 	} else {
	// 		return <></>
	// 		// return <Col sm={24}>
	// 		// 	<Form.Item label={'Số lượng hàng tồn kho'}>
	// 		// 		{getFieldDecorator('stockQuantity', {})(
	// 		// 			<Input type={'number'} min={0} placeholder={'Nhập số lượng hàng tồn kho'} />
	// 		// 		)}
	// 		// 	</Form.Item>
	// 		// </Col>;
	// 	}
	// };

	return (
		<Fragment>
			<Card title="Thông tin chung">
				<Form.Item
					label={renderTitle('Tên sản phẩm', 'Tên sản phẩm không bao gồm các giá trị thuộc tính như màu sắc, chất liệu, kích cỡ...')}
					required>
					{getFieldDecorator('name', {
						rules: [{ required: true, message: 'Vui lòng nhập tên sản phẩm' }]
					})(
						<Input placeholder="Nhập tên sản phẩm" allowClear />
					)}
				</Form.Item>
				<Form.Item>
					<p style={{ textAlign: 'left', margin: 0 }}><span>Sản phẩm thường: </span> <Checkbox checked={isNormalProduct}
																																																onChange={e => setIsNormalProduct(e.target.checked)} />
					</p>
				</Form.Item>
				<Row gutter={12}>
					{/*{renderImeiOrNormal()}*/}
					{/*<Col sm={12}>*/}
					{/*	<Form.Item*/}
					{/*		label={renderTitle('Mã sản phẩm/SKU', <p>Mã <b>không trùng lặp</b> để định danh giữa các sản phẩm. Nếu để*/}
					{/*			trống trường này, mã sản phẩm sẽ được tự sinh với <b>tiền tố PVN</b></p>)}>*/}
					{/*		{getFieldDecorator('sku', { message: 'Vui lòng nhập SKU' })(*/}
					{/*			<Input allowClear placeholder={'Nhập mã sản phẩm/SKU'} />*/}
					{/*		)}*/}
					{/*	</Form.Item>*/}
					{/*</Col>*/}
					<Col sm={12}>
						<Form.Item label="Khối lượng">
							{getFieldDecorator('weight', {
								initialValue: 0
							})(
								<Input type={'number'} min={0} addonAfter={afterOptions()} allowClear />
							)}
						</Form.Item>
					</Col>
					<Col sm={12}>
						<Form.Item label={'Đơn vị tính'}>
							{getFieldDecorator('unitName')(
								<Input allowClear placeholder={'Nhập đơn vị tính'} />)}
						</Form.Item>
					</Col>
				</Row>
			</Card>
		</Fragment>
	);
};
